export default __webpack_public_path__ + "static/media/032-no stopping.d7c7b42a.png";